export { localeFromCountry, getDictionary } from "./locales";
export type { WebLocale, WebDictionary } from "./locales";
export { LocaleProvider, useLocale } from "./context";
